
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider } from "./contexts/AuthContext";
import { VoiceProvider } from "./contexts/VoiceContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import AuthCallback from "./pages/AuthCallback";
import PasswordReset from "./pages/PasswordReset";
import SlackIntegration from "./pages/SlackIntegration";
import SlackCallback from "./pages/SlackCallback";
import CalendarIntegration from "./pages/CalendarIntegration";
import CalendarCallback from "./pages/CalendarCallback";
import Privacy from "./pages/Privacy";
import TermsOfService from "./pages/TermsOfService";
import Upgrade from "./pages/Upgrade";
import CookieConsent from "./components/CookieConsent";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <TooltipProvider>
        <AuthProvider>
          <VoiceProvider>
            <Toaster />
            <Sonner />
            <CookieConsent />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/password-reset" element={<PasswordReset />} />
                <Route path="/slack" element={<SlackIntegration />} />
                <Route path="/slack/callback" element={<SlackCallback />} />
                <Route path="/calendar" element={<CalendarIntegration />} />
                <Route path="/calendar/callback" element={<CalendarCallback />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/tos" element={<TermsOfService />} />
                <Route path="/upgrade" element={<Upgrade />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </VoiceProvider>
        </AuthProvider>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
